import convertSelectionToFilter from "core-web/utils/convertSelectionToFilter";

/**
 * Transform productSelection data from the cms so that it is easier to use in the front-end.
 * The products can be selected manualy, by category or by tags.
 * @param {object} productSelection - Data about selected products straight from the cms.
 * @param {object} - Transformed link data.
 */

export default (productSelection) => {
    // Just return false if we don't have any data
    if (!productSelection) {
        return false;
    }

    const selectionType = productSelection?.layout;

    // How should Algolia get the correct products? By id? By category? etc.
    let type = null;

    // Parameters that Algolia will use to get the correct products. Products ids, category ids etc.
    let values = null;

    let pageSize = null;

    let selection = null;

    let isDistinct = true;

    switch (selectionType) {
        case "manual": {
            type = "id";
            const products = productSelection?.products || [];
            values = products.map((p) => (typeof p === "object" ? p.objectID : p));
            pageSize = values.length;
            break;
        }
        case "automatic": {
            const { automatic_products_selection: automaticSelection, products_amount: productsAmount } =
                productSelection || {};
            selection = convertSelectionToFilter(automaticSelection);
            type = "filter";
            pageSize = parseInt(productsAmount, 10);
            if (automaticSelection.hasOwnProperty("group_variants")) {
                isDistinct = automaticSelection.group_variants;
            }
            break;
        }
        default: {
            pageSize = productSelection.pageSize;
            break;
        }
    }

    return {
        type,
        values,
        pageSize,
        selection,
        isDistinct,
    };
};
